// extracted by mini-css-extract-plugin
module.exports = {"header":"HomePage_header__Tp_9X","banner":"HomePage_banner__1xV4J","title":"HomePage_title__3mBKn","subtitle":"HomePage_subtitle__2RrdA"};